import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

const withServerError = (fn) => async (arg, { rejectWithValue }) => {
  try {
    return await fn(arg);
  } catch (error) {
    return rejectWithValue(
      error.response?.data || { success: false, message: error.message }
    );
  }
};

export const reviewBody = (res) => res?.payload?.data ?? res?.payload ?? null;

export const SubmitReview = createAsyncThunk(
  "propertyReview/submit",
  withServerError(({ tenancyRequestId, rating, comment }) =>
    axios.post(`${BASE_URL}/property-reviews`, { tenancyRequestId, rating, comment })
  )
);

export const RespondToReview = createAsyncThunk(
  "propertyReview/ownerResponse",
  withServerError(({ id, message }) =>
    axios.post(`${BASE_URL}/property-reviews/${id}/owner-response`, { message })
  )
);

// Public — no auth needed, used on listing pages.
export const GetPropertyReviews = createAsyncThunk(
  "propertyReview/getForFlat",
  withServerError(({ flatId }) => axios.get(`${BASE_URL}/property-reviews/${flatId}`))
);

export const GetTenantReviews = createAsyncThunk(
  "propertyReview/getMine",
  withServerError(({ tenantId }) =>
    axios.get(`${BASE_URL}/property-reviews/mine/${tenantId}`)
  )
);

// Either party, any status — unlike GetPropertyReviews, which is public and
// approved-only.
export const GetReviewForTenancy = createAsyncThunk(
  "propertyReview/getForTenancy",
  withServerError(({ tenancyRequestId }) =>
    axios.get(`${BASE_URL}/property-reviews/tenancy/${tenancyRequestId}`)
  )
);

const PropertyReviewSlice = createSlice({
  name: "propertyReview",
  initialState: {
    loading: false,
    reviews: [],
    average: 0,
    count: 0,
    mine: [],
    forTenancy: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetPropertyReviews.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetPropertyReviews.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload?.data?.data;
        state.reviews = data?.reviews || [];
        state.average = data?.average || 0;
        state.count = data?.count || 0;
      })
      .addCase(GetPropertyReviews.rejected, (state) => {
        state.loading = false;
      })
      .addCase(GetTenantReviews.fulfilled, (state, action) => {
        state.mine = action.payload?.data?.data || [];
      })
      .addCase(GetReviewForTenancy.fulfilled, (state, action) => {
        state.forTenancy = action.payload?.data?.data || null;
      })
      .addCase(RespondToReview.fulfilled, (state, action) => {
        const updated = action.payload?.data?.data;
        if (updated) state.forTenancy = updated;
      });
  },
});

export default PropertyReviewSlice.reducer;
